import {SMSWOUnifiedDashboardServiceLambda} from "@amzn/swo-unified-dashboard-service-lambda-js-client";
import {unifiedDashboardAPIConfig} from "src/utils/api-gateway/swo-ud-api-mappings";
import {getStage} from "src/utils/env";

export class WebsiteViewService {
    private unifiedDashboardServiceLambda: SMSWOUnifiedDashboardServiceLambda;

    constructor() {
        const unifiedDashboardConfig = unifiedDashboardAPIConfig(getStage());
        this.unifiedDashboardServiceLambda = new SMSWOUnifiedDashboardServiceLambda({
            endpoint: `https://${unifiedDashboardConfig.endpoint}/${unifiedDashboardConfig.stage}`,
            region: unifiedDashboardConfig.region
        })
    }
    async getWebsiteMetadata(website: string, websiteId?: number|null) {
        return websiteId && websiteId > 0 ? this.unifiedDashboardServiceLambda
            .getWebsiteMetadata({domain: website, websiteId: websiteId}).promise()
            : this.unifiedDashboardServiceLambda
            .getWebsiteMetadata({domain: website}).promise();
    }

    async getWebsiteEvents(website: string) {
        return this.unifiedDashboardServiceLambda.getWebsiteEvents({domain: website}).promise()
    }

    async searchWebsites(query: string, searchProp: string) {
        return this.unifiedDashboardServiceLambda.searchDomains({query, searchProperty: searchProp}).promise()
    }
    
    async getWebsiteMetrics(website: string) {
        return this.unifiedDashboardServiceLambda.getWebsiteViewMetrics({domain: website}).promise()
    }

    async getPrimitivePointInTimeMetrics(website: string, metricFor?: string) {
        return this.unifiedDashboardServiceLambda.getWebsiteViewMetrics({domain: website, namespace: metricFor}).promise()
    }
}
